module.exports = __webpack_public_path__ + "static/img/france-flag-256.e2f669c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/france-flag-256.png
// module id = IvLL
// module chunks = 1